
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { IconList } from '@ecl/website-components';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`The icons are separated into four categories.`}</p>
    <h2>{`Social media`}</h2>
    <p>{`These are icons of social media sites with one colour overlay. We use them in the footer.`}</p>
    <IconList set="branded" mdxType="IconList" />
    <h2>{`General`}</h2>
    <p>{`This is the largest group. We use the icons in many components from accordion to list.`}</p>
    <IconList set="general" mdxType="IconList" />
    <h2>{`Notifications`}</h2>
    <IconList set="notifications" mdxType="IconList" />
    <h2>{`UI`}</h2>
    <p>{`These icons are part of UI (like arrows or external icon for links).`}</p>
    <IconList set="ui" mdxType="IconList" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;